import couponsRepository from "./couponsRepository";
import appsRepository from "./appsRepository";
import tiersRepository from "./tiersRepository";
import clientsRepository from "./clientsRepository";
import rewardsRepository from "./rewardsRepository";
import redeemRepository from "./redeemRepository";

export const repositories = {
  couponsRepository,
  appsRepository,
  tiersRepository,
  rewardsRepository,
  redeemRepository,
  clientsRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
